import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path:"/",
		name:"navigation",
		component:() => import('../views/navigation.vue')
	},
	{
		path:'/HouseholdUse',
		name:'householdUse',
		component:() => import('../views/HouseholdUse/index.vue'),
		meta:{
			title:'户用测算页',
		}
	},{
		path:'/Commercial',
		name:'Commercial',
		component:() => import('../views/Commercial/index.vue'),
		meta:{
			title:'商用测算页',
		}
	},
  {
    path: '/productComparison',
    name: 'ProductComparison',
    component: () => import('../views/Product/product-compare.vue'),
		meta:{
			title:'产品对比页',
		}
  },
	{
		path: '/equipmentSelection',
		name: 'EquipmentSelection',
		component: () => import('../views/Product/equipment-selection.vue'),
		meta:{
			title:'设备选型',
		}
	}
]

const router = new VueRouter({
//   mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
